import imageCompression, { Options } from "browser-image-compression";
import { DEFAULT_IMAGE_COMPRESS_THRESHOLD_SIZE_KB, MIN_IMAGE_COMPRESS_THRESHOLD_SIZE_KB } from "./constants";
import { getBytesInMB, getKBInMB, isFileTypeImage } from "./index";

export interface ImageCompressorOptions extends Options {}

export default class ImageCompressor {
  static defaultOptions: ImageCompressorOptions = {
    maxSizeMB: getKBInMB(DEFAULT_IMAGE_COMPRESS_THRESHOLD_SIZE_KB),
    useWebWorker: true
  };
  static async getCompressedImage(file: File, options?: ImageCompressorOptions) {
    if (!isFileTypeImage(file)) {
      return file;
    }
    const defaultOptions = { ...ImageCompressor.defaultOptions, ...options };
    const fileSizeInMB = getBytesInMB(file.size);
    const minCompressThresholdInMB = getKBInMB(MIN_IMAGE_COMPRESS_THRESHOLD_SIZE_KB);
    const allowedMaxSizeInMB = defaultOptions.maxSizeMB;

    if (fileSizeInMB <= minCompressThresholdInMB || !allowedMaxSizeInMB) {
      return file;
    } else if (fileSizeInMB > minCompressThresholdInMB && fileSizeInMB <= allowedMaxSizeInMB) {
      try {
        const compressToSizeInMB = getBytesInMB(file.size) * 0.9; // Compress to 10 %
        return imageCompression(file, { ...defaultOptions, maxSizeMB: compressToSizeInMB });
      } catch (e) {
        return file;
      }
    }
    return imageCompression(file, defaultOptions);
  }
}
